import { FontsWeb } from '@shell/compat/FontsWeb'
import Toasts from '@ui/toasts/Toasts'
import { colors } from '@ui/colors'
import ActivityMonitor from '@ui/components/ActivityMonitor/ActivityMonitor'
import { PortalHost, PortalProvider } from '@gorhom/portal'
import ApiProvider from 'api/ApiProvider'
import AppConfig from 'config'
import { StatusBar } from 'expo-status-bar'
import useAppActivity from 'hooks/activity/useAppActivity'
import React, { Suspense } from 'react'
import { Platform } from 'react-native'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import { KeyboardProvider } from 'react-native-keyboard-controller'
import RootQueries from './RootQueries'
import AppErrorBoundary from 'providers/AppErrorBoundary'

const Providers = ({ children }: { children: React.ReactNode }) => {
  const setAppActive = useAppActivity((s) => s.setActive)

  return (
    <KeyboardProvider>
      <ApiProvider>
        <Suspense>
          {Platform.OS === 'web' && <FontsWeb />}
          <RootQueries />
          <StatusBar hidden />
          <GestureHandlerRootView
            style={{ flex: 1, backgroundColor: colors.white }}
          >
            <AppErrorBoundary>
              <ActivityMonitor
                maxActivityAgeMs={AppConfig.activity.maxActivityAgeMs}
                setActive={setAppActive}
              >
                <PortalProvider shouldAddRootHost={false}>
                  {children}
                  <PortalHost name={Toasts.TOASTS_HOST} />
                  <Toasts />
                </PortalProvider>
              </ActivityMonitor>
            </AppErrorBoundary>
          </GestureHandlerRootView>
        </Suspense>
      </ApiProvider>
    </KeyboardProvider>
  )
}

export default Providers
